import { render, staticRenderFns } from "./readings.vue?vue&type=template&id=64207092&scoped=true"
import script from "./readings.vue?vue&type=script&lang=js"
export * from "./readings.vue?vue&type=script&lang=js"
import style0 from "./readings.vue?vue&type=style&index=0&id=64207092&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64207092",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64207092')) {
      api.createRecord('64207092', component.options)
    } else {
      api.reload('64207092', component.options)
    }
    module.hot.accept("./readings.vue?vue&type=template&id=64207092&scoped=true", function () {
      api.rerender('64207092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/site_details/readings.vue"
export default component.exports